import React from "react";
import "./App.css";
import Home from "./pages/Home";
import Ligas from "./pages/Ligas";
import MyNavbar from "./components/MyNavbar";
import { HashRouter as Router, Route, Routes } from "react-router-dom";
import LeaguePage from "./pages/LeaguePage";
import field1 from "./images/field1.png";
import SuspensionsPage from "./pages/SuspensionsPage";
import PartidosPage from "./pages/PartidosPage";
import FlyersPage from "./pages/FlyersPage";
import MyTeamsPage from "./pages/MyTeamsPage";
import { AuthProvider } from "./auth";
import { SiteSettingsProvider } from "./siteSettings";
import MobileBottomNav from "./components/MobileBottomNav";
import AppErrorBoundary from "./components/AppErrorBoundary";
import NotFoundPage from "./pages/NotFoundPage";

// HashRouter owns the URL hash, so move focus instead of following "#main-content".
function skipToMain(event) {
  event.preventDefault();
  document.getElementById("main-content")?.focus();
}

function App() {
  return (
    <AppErrorBoundary>
    <SiteSettingsProvider>
    <AuthProvider>
      <div className="app-shell">
        <Router>
          <a href="#main-content" className="skip-link" onClick={skipToMain}>
            Saltar al contenido
          </a>
          <MyNavbar />
          <main id="main-content" className="app-main" tabIndex={-1}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/inicio" element={<Home />} />
            <Route path="/ligas" element={<Ligas />} />
            <Route path="/ligas/:leagueId" element={<LeaguePage bannerImage={field1} />} />
            <Route path="/suspensiones" element={<SuspensionsPage bannerImage={field1} />} />
            <Route path="/partidos" element={<PartidosPage />} />
            <Route path="/noticias" element={<FlyersPage bannerImage={field1} />} />
            <Route path="/volantes" element={<FlyersPage bannerImage={field1} />} />
            <Route
              path="/mis-equipos"
              element={<MyTeamsPage bannerImage={field1} />}
            />
            <Route
              path="/inscribir"
              element={<MyTeamsPage bannerImage={field1} />}
            />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
          </main>
          <MobileBottomNav />
        </Router>
      </div>
    </AuthProvider>
    </SiteSettingsProvider>
    </AppErrorBoundary>
  );
}

export default App;
